module.exports = "<router-outlet></router-outlet>\n<app-navigation> </app-navigation>\n"